<template>
  <Modal :closeBtn="true" @close="closeModal">
    <CircleLoader :inline="true" v-if="gettingData"></CircleLoader>
    <div v-else class="confirm-your-refinance-details-modal">
      <h1>Confirm Your Refinance Details</h1>
      <p>Before you sign, please review your loans, payoffs, and terms.</p>
      <div class="loans-to-refinance-section-wrapper">
        <LoansToRefinanceTable
          :showPayoffDetails="true"
          :showActionsColumn="false"
          :showAddLoanButton="false"
          id="Parent_ConfirmYourRefinanceDetailsModal"
        ></LoansToRefinanceTable>
      </div>
      <div class="two-column-grid">
        <refi-loan-configuration-details />
        <div>
          <p class="italic">
            By clicking Ready to Sign, you acknowledge that you have reviewed and agree with all
            payoff details listed above.
          </p>
          <next-button
            :disabled="loading"
            :loading="loading"
            text="Ready to Sign"
            @click.prevent="confirmChangesREFI"
          />
        </div>
      </div>
      <div v-if="esignResponseError" class="text-center error">
        {{ esignErrorMessage }} Please try again later. If the issue persists, please contact our
        support team.
      </div>
      <dialogue-modal
        v-if="showDialogueModal === true"
        @cancel="showDialogueModal = false"
        @confirm="handleDialogueModal"
        :title="`Quit editing?`"
        :msg="`Any changes you\'ve made so far will not be saved`"
        :confirmButtonText="'Yes'"
        :cancelButtonText="'No'"
      />
    </div>
  </Modal>
</template>
<script setup lang="ts">
import { ref, computed, onMounted } from "vue";
import { useStore } from "vuex";
import DialogueModal from "@/components/modals/DialogueModal.vue";
import LoansToRefinanceTable from "@/components/refi-loans-table/LoansToRefinanceTable.vue";
import Modal from "@/components/shared/Modal.vue";
import NextButton from "@/components/shared/NextButton.vue";
import RefiLoanConfigurationDetails from "@/components/refi-loan-configuration/RefiLoanConfigurationDetails.vue";
import CircleLoader from "@/components/shared/CircleLoader.vue";
import useEsignConfirmation from "@/composables/useEsignConfirmation";

const store = useStore();

const emit = defineEmits(["close"]);

const { confirmChangesREFI, esignErrorMessage, esignResponseError, gettingData, loading } =
  useEsignConfirmation();

const showDialogueModal = ref<boolean>(false);

const loans = computed(() => store?.getters["applicationInfoModule/RefiLoans"]);

function openDialogueModal() {
  showDialogueModal.value = true;
}

function handleDialogueModal() {
  store.dispatch("applicationInfoModule/discardChanges");
  store.dispatch("applicationInfoModule/closeModal", "ConfirmYourRefinanceDetails");
}

function closeModal() {
  showDialogueModal.value = true;
}

async function getRefiLoanDetailsModal() {
  await store.dispatch(
    "applicationInfoModule/getRefiLoanModalData",
    store.state.appData?.application?.id,
  );

  gettingData.value = false;
}

onMounted(() => {
  gettingData.value = true;
  getRefiLoanDetailsModal();
});

defineExpose({
  closeModal,
  getRefiLoanDetailsModal,
  handleDialogueModal,
  loans,
  openDialogueModal,
});
</script>
<style scoped>
.two-column-grid {
  display: grid;
  grid-auto-rows: 1fr;
  grid-template-columns: 1.875fr 1fr;
  column-gap: 1rem;
}

.confirm-your-refinance-details-modal {
  padding: 0 1em;
}
.loans-to-refinance-section-wrapper {
  margin-bottom: 1rem;
}
.text-center {
  text-align: center;
}

@media (max-width: 575px) {
  .two-column-grid {
    display: flex;
    flex-direction: column;
  }
}
</style>
